import { aboutInfo } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">{aboutInfo.title}</h2>
          <p className="text-sm text-cinema-muted">影视搜索 · 智能推荐 · 高清在线</p>
        </div>

        <div className="bg-cinema-card border border-cinema-border rounded-xl p-6 md:p-10 mb-10">
          <div className="space-y-4">
            {aboutInfo.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-cinema-text-dim leading-relaxed">{p}</p>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {aboutInfo.stats.map((stat, i) => (
            <div key={i} className="bg-cinema-card border border-cinema-border rounded-lg p-5 text-center">
              <div className="text-2xl md:text-3xl font-bold text-cinema-gold font-heading mb-1">{stat.value}</div>
              <div className="text-xs text-cinema-muted">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}